import { useIntl } from '@/intl'
import {
  golfEditingValueForSlotSelector,
  golfTimesSelector,
} from '@/scopes/checkout/components/services/GolfService/selectors'
import {
  getGolfSlotIdBeingEdited,
  useGolfServiceStore,
} from '@/scopes/checkout/components/services/GolfService/store'
import { updateEditingGolfSlotTime } from '@/scopes/checkout/domain/actions'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import { Dropdown } from '@sunwebgroup/uds-ui/dropdown'
import * as React from 'react'

export function TimeSelector() {
  const intl = useIntl()
  const { service, setServiceLocalValue } = useService(ServiceType.Golf)
  const slotId = useGolfServiceStore(getGolfSlotIdBeingEdited)

  const availableTimes = golfTimesSelector(service)

  const slot = golfEditingValueForSlotSelector(service, slotId)

  const handleChange = (time: string) => {
    if (!slotId)
      return
    setServiceLocalValue(updateEditingGolfSlotTime({ slotId, time }))
  }

  if (!slot)
    return null

  return (
    <Dropdown.Root value={slot?.time ?? ''} onValueChange={handleChange}>
      <Dropdown.Trigger
        label={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_time_label' })}
      />
      <Dropdown.Content>
        {availableTimes.map(time => (
          <Dropdown.Item key={time} value={time}>{intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_time_available_text' }, { time })}</Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown.Root>
  )
}
